import { DoesNotExistError } from '@helia/unixfs/errors';
import {} from '@libp2p/interface';
import { abortableSource } from 'abortable-iterator';
import {} from 'interface-blockstore';
import { walkPath as exporterWalk } from 'ipfs-unixfs-exporter';
import { badGatewayResponse, notFoundResponse } from './responses.js';
async function walkPath(blockstore, path, options) {
    const ipfsRoots = [];
    let terminalElement;
    const iterator = options?.signal != null ? abortableSource(exporterWalk(path, blockstore, options), options.signal) : exporterWalk(path, blockstore, options);
    for await (const entry of iterator) {
        ipfsRoots.push(entry.cid);
        terminalElement = entry;
    }
    if (terminalElement == null) {
        throw new DoesNotExistError('No terminal element found');
    }
    return {
        ipfsRoots,
        terminalElement
    };
}
export function isObjectNode(node) {
    return node.type === 'object';
}
/**
 * Attempts to walk the path in the blockstore, returning ipfsRoots needed to resolve the path, and the terminal element.
 * If the signal is aborted, the function will throw an AbortError
 * If a terminal element is not found, a notFoundResponse is returned
 * If another unknown error occurs, a badGatewayResponse is returned
 *
 */
export async function handlePathWalking({ cid, path, resource, options, blockstore, log }) {
    try {
        return await walkPath(blockstore, `${cid.toString()}/${path}`, options);
    }
    catch (err) {
        options?.signal?.throwIfAborted();
        if (['ERR_NO_PROP', 'ERR_NO_TERMINAL_ELEMENT', 'ERR_NOT_FOUND'].includes(err.code)) {
            return notFoundResponse(resource);
        }
        log.error('error walking path %s', path, err);
        return badGatewayResponse(resource, 'Error walking path');
    }
}
//# sourceMappingURL=walk-path.js.map